import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";
import { SelectableItem } from "./select-team-or-org";

export const mapItemsToComboBoxItemModel = (
  items: SelectableItem[]
): ComboBoxItemModel[] => {
  return items?.map(item => {
    return {
      value: item.id,
      caption: item.name
    };
  });
};
